import React, { Children, FC, cloneElement } from 'react'
import { WidgetInputWrapperProps } from '../../widget-inputs.d'
import styles from '../../widget-inputs.module.scss'

export const WidgetInputWrapper: FC<WidgetInputWrapperProps> = ({
  children,
}) => {
  return (
    <div
      className={`${styles['form__group']}`}
      data-testid="widget-input-wrapper"
    >
      {Children.map(children, (child: any) =>
        child
          ? cloneElement(child, {
              className: `${child.props.className}`,
            })
          : null
      )}
    </div>
  )
}
